// tslint:disable:no-var-requires
const linksInfo = require('../data/link_info.json');
// tslint:enable:no-var-requires


export const LinkInfo = (name: string) => {
  return linksInfo[name];
};


// WEBPACK FOOTER //
// ./src/app/models/link_info.ts